import { Component, OnInit, Inject } from '@angular/core';
import { UserBooksService } from '@add-symbol-service';
import { Utils, EVENTS, EDIS_SERVER_URL } from 'src/app/_helpers';
import { SharedUtils } from 'sharedweb/helpers/shared.utilities';
import { GenericRequestsService, EventsService } from '../../providers';
import { ConfigParams, RegenerateTPINRequest, EDISPopUpData, EDISEncryptResponse, EDISEncryptRevokeResponse, genericResponse } from 'sharedweb/app.interface';
import { EdisService } from 'sharedweb/providers/edis/edis.service';
import { PlatformType, EDISAction } from 'sharedweb/app.structs';
import { ToastrService } from 'ngx-toastr';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { getCDSLExtendedInfo, REGENERATE_SUCCESS, REGENERATE_FAILURE } from 'sharedweb/strings/edis.strings';
import { ConfigParamsService } from 'sharedweb/providers/config-params/config-params.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-edis-popup',
  templateUrl: './edis-popup.component.html',
  styleUrls: ['./edis-popup.component.scss']
})
export class EdisPopupComponent implements OnInit {

  openTextBool = false;
  config: ConfigParams;
  extendedPoints = getCDSLExtendedInfo();
  isProceedLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EDISPopUpData,
    private userBookService: UserBooksService,
    private cacheService: ConfigParamsService,
    private edisService: EdisService,
    private toast: ToastrService,
    private dialogRef: MatDialogRef<EdisPopupComponent>,
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    this.cacheService.getConfigParams().then(config => {
      this.config = config;
    });

  }

  toggleText() {
    this.openTextBool = !this.openTextBool;
  }

  proceedToCDSL() {
    this.isProceedLoading = true;
    const data = SharedUtils.prepDataForCDSLEncryption(this.data.selectedHoldings, this.config.edis_info, PlatformType.WEB, EDIS_SERVER_URL, this.data.action);
    let encryptData : Observable<EDISEncryptResponse | EDISEncryptRevokeResponse> = (this.data.action == EDISAction.Authorize) ? this.edisService.encryptAuthorizeData(data) : this.edisService.encryptUnAuthorizeData(data);
    encryptData.subscribe( response => {
      this.isProceedLoading = false;
      const form = this.data.action == EDISAction.Authorize ? SharedUtils.createEDISForm(document, data, response as EDISEncryptResponse) : SharedUtils.createEDISRevokeForm(document, data, response as EDISEncryptRevokeResponse);

      let newWindow : Window;
      let timer: number;
      this.edisService.window  =  newWindow = window.open('', 'CDSL-PIN', 'width=800,height=900,toolbar=no');
      if (window.focus) {
        newWindow.focus();
      }
      form.setAttribute('target', 'CDSL-PIN');
      newWindow.document.body.appendChild(form);
      form.submit();

      this.edisService.timer = timer = window.setInterval(() => {
        if (newWindow.closed) {
          clearInterval(timer);
          this.edisService.window = newWindow = null;
          let edisHoldings = {};
          for (let i=0; i < this.data.selectedHoldings.length;  i++){
            edisHoldings[this.data.selectedHoldings[i].isin] = this.data.selectedHoldings[i];
          }
          this.eventsService.publish(
            EVENTS.CONFIRM_EDIS_STATUS,
            {
              edisAction: this.data.action,
              recordsSentLength: this.data.selectedHoldings.length,
              data: edisHoldings
            }
          );
          if (this.data.action === EDISAction.Unauthorize) {
            const transactions = this.getCancelTransaction();
            this.edisService.getUnauthorizeCancelQty(transactions).subscribe((res: genericResponse) => {
              console.log(`API Call Made Successfully.`, res.message);
            }, err => {
              console.log(`API Call Failed with revocID.`, err);
            })
          }      
          /**
           * Check if dialog is closed after CDSL pin verification is done or not.
           */
          this.dialogRef.close(true);
        }
      }, 500);
    }, error => {
      this.isProceedLoading = false;
    });
  }

  getCancelTransaction(): string[] {
    // RE-688 From Holdings Transaction extracting second element from each array.
    const transactionRequests = [];
    this.data.selectedHoldings.forEach(holding => {
        holding.transactions.forEach(transaction => {
            if (transaction.length > 1) { // Ensure there's a second element
                transactionRequests.push(transaction[1]);
            }
        });
    });
    return transactionRequests;
}

  regenerateTPIN() {
    const data: RegenerateTPINRequest = {
      Version: '1.1',
      BoID: this.config.edis_info.bo_id,
      PAN: this.config.edis_info.pan,
      ReqFlag: 'Y'
    };
    this.edisService.regenerateTPIN(data).subscribe(res => {
      if (res.success) {
        this.toast.success(REGENERATE_SUCCESS, 'Success');
        this.dialogRef.close();
      }

    }, _ => {
      this.toast.error(REGENERATE_FAILURE, 'Error');
      this.dialogRef.close();
    });
  }


}
